import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ExtractionColumnController::store
* @see Http/Controllers/ExtractionColumnController.php:19
* @route '/extraction/grids/{grid}/columns'
*/
export const store = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/extraction/grids/{grid}/columns',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionColumnController::store
* @see Http/Controllers/ExtractionColumnController.php:19
* @route '/extraction/grids/{grid}/columns'
*/
store.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return store.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionColumnController::store
* @see Http/Controllers/ExtractionColumnController.php:19
* @route '/extraction/grids/{grid}/columns'
*/
store.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::store
* @see Http/Controllers/ExtractionColumnController.php:19
* @route '/extraction/grids/{grid}/columns'
*/
const storeForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::store
* @see Http/Controllers/ExtractionColumnController.php:19
* @route '/extraction/grids/{grid}/columns'
*/
storeForm.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\ExtractionColumnController::reorder
* @see Http/Controllers/ExtractionColumnController.php:66
* @route '/extraction/grids/{grid}/columns/reorder'
*/
export const reorder = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reorder.url(args, options),
    method: 'post',
})

reorder.definition = {
    methods: ["post"],
    url: '/extraction/grids/{grid}/columns/reorder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionColumnController::reorder
* @see Http/Controllers/ExtractionColumnController.php:66
* @route '/extraction/grids/{grid}/columns/reorder'
*/
reorder.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return reorder.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionColumnController::reorder
* @see Http/Controllers/ExtractionColumnController.php:66
* @route '/extraction/grids/{grid}/columns/reorder'
*/
reorder.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reorder.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::reorder
* @see Http/Controllers/ExtractionColumnController.php:66
* @route '/extraction/grids/{grid}/columns/reorder'
*/
const reorderForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::reorder
* @see Http/Controllers/ExtractionColumnController.php:66
* @route '/extraction/grids/{grid}/columns/reorder'
*/
reorderForm.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(args, options),
    method: 'post',
})

reorder.form = reorderForm

/**
* @see \App\Http\Controllers\ExtractionColumnController::update
* @see Http/Controllers/ExtractionColumnController.php:38
* @route '/extraction/columns/{column}'
*/
export const update = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/extraction/columns/{column}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ExtractionColumnController::update
* @see Http/Controllers/ExtractionColumnController.php:38
* @route '/extraction/columns/{column}'
*/
update.url = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { column: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { column: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            column: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        column: typeof args.column === 'object'
        ? args.column.id
        : args.column,
    }

    return update.definition.url
            .replace('{column}', parsedArgs.column.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionColumnController::update
* @see Http/Controllers/ExtractionColumnController.php:38
* @route '/extraction/columns/{column}'
*/
update.patch = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::update
* @see Http/Controllers/ExtractionColumnController.php:38
* @route '/extraction/columns/{column}'
*/
const updateForm = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::update
* @see Http/Controllers/ExtractionColumnController.php:38
* @route '/extraction/columns/{column}'
*/
updateForm.patch = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ExtractionColumnController::destroy
* @see Http/Controllers/ExtractionColumnController.php:54
* @route '/extraction/columns/{column}'
*/
export const destroy = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/extraction/columns/{column}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ExtractionColumnController::destroy
* @see Http/Controllers/ExtractionColumnController.php:54
* @route '/extraction/columns/{column}'
*/
destroy.url = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { column: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { column: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            column: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        column: typeof args.column === 'object'
        ? args.column.id
        : args.column,
    }

    return destroy.definition.url
            .replace('{column}', parsedArgs.column.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionColumnController::destroy
* @see Http/Controllers/ExtractionColumnController.php:54
* @route '/extraction/columns/{column}'
*/
destroy.delete = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::destroy
* @see Http/Controllers/ExtractionColumnController.php:54
* @route '/extraction/columns/{column}'
*/
const destroyForm = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionColumnController::destroy
* @see Http/Controllers/ExtractionColumnController.php:54
* @route '/extraction/columns/{column}'
*/
destroyForm.delete = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const ExtractionColumnController = { store, reorder, update, destroy }

export default ExtractionColumnController